module.exports = __webpack_public_path__ + "fa-brands-400.woff?a046592bac8f2fd96e994733faf3858c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.woff
// module id = 38
// module chunks = 0